export default __webpack_public_path__ + "static/Commercial-Cleanout-b6b23f13b7c16ec26367104d1c5243db.jpg";